import { NetworkTypeEnum } from '../../Core/enums/network-type.enum';
import { MediaTypeModel } from '../../../Monitor/Shared/models/media-type.model';
import { MediaTypeEnum } from '@Common/Basic/enums/media-type.enum';

export const networkTypeToMediaTypeModelMap = new Map<NetworkTypeEnum, MediaTypeModel[]>([
    [NetworkTypeEnum.all, [
        new MediaTypeModel(MediaTypeEnum.TWITTER),
        new MediaTypeModel(MediaTypeEnum.FACEBOOK),
        new MediaTypeModel(MediaTypeEnum.INSTAGRAM),
        new MediaTypeModel(MediaTypeEnum.TIKTOK),
        new MediaTypeModel(MediaTypeEnum.YOUTUBE),
        new MediaTypeModel(MediaTypeEnum.REDDIT),
        new MediaTypeModel(MediaTypeEnum.LINKEDIN),
        new MediaTypeModel(MediaTypeEnum.BLUESKY),
    ]],
    [NetworkTypeEnum.twitter,   [new MediaTypeModel(MediaTypeEnum.TWITTER)]   ],
    [NetworkTypeEnum.facebook,  [new MediaTypeModel(MediaTypeEnum.FACEBOOK)]  ],
    [NetworkTypeEnum.instagram, [new MediaTypeModel(MediaTypeEnum.INSTAGRAM)] ],
    [NetworkTypeEnum.tiktok,    [new MediaTypeModel(MediaTypeEnum.TIKTOK)]    ],
    [NetworkTypeEnum.youtube,   [new MediaTypeModel(MediaTypeEnum.YOUTUBE)]   ],
    [NetworkTypeEnum.reddit,    [new MediaTypeModel(MediaTypeEnum.REDDIT)]    ],
    [NetworkTypeEnum.linkedin,  [new MediaTypeModel(MediaTypeEnum.LINKEDIN)]  ],
    [NetworkTypeEnum.bluesky,   [new MediaTypeModel(MediaTypeEnum.BLUESKY)]   ],

]);

export const mediaTypeToNetworkTypeMap = new Map<MediaTypeEnum, NetworkTypeEnum>([
    [ MediaTypeEnum.TWITTER,   NetworkTypeEnum.twitter   ],
    [ MediaTypeEnum.FACEBOOK,  NetworkTypeEnum.facebook  ],
    [ MediaTypeEnum.INSTAGRAM, NetworkTypeEnum.instagram ],
    [ MediaTypeEnum.TIKTOK,    NetworkTypeEnum.tiktok    ],
    [ MediaTypeEnum.YOUTUBE,   NetworkTypeEnum.youtube   ],
    [ MediaTypeEnum.REDDIT,    NetworkTypeEnum.reddit    ],
    [ MediaTypeEnum.LINKEDIN,  NetworkTypeEnum.linkedin  ],
    [ MediaTypeEnum.BLUESKY,   NetworkTypeEnum.bluesky   ],
]);

export const networkTypeToMediaTypeMap = new Map<NetworkTypeEnum, MediaTypeEnum>([
    [ NetworkTypeEnum.twitter,   MediaTypeEnum.TWITTER   ],
    [ NetworkTypeEnum.facebook,  MediaTypeEnum.FACEBOOK  ],
    [ NetworkTypeEnum.instagram, MediaTypeEnum.INSTAGRAM ],
    [ NetworkTypeEnum.tiktok,    MediaTypeEnum.TIKTOK    ],
    [ NetworkTypeEnum.youtube,   MediaTypeEnum.YOUTUBE   ],
    [ NetworkTypeEnum.reddit,    MediaTypeEnum.REDDIT    ],
    [ NetworkTypeEnum.linkedin,  MediaTypeEnum.LINKEDIN  ],
    [ NetworkTypeEnum.bluesky,   MediaTypeEnum.BLUESKY   ],
]);
